import React from "react";
import { neturalBlack, netural400, netural50 } from "../../../constants/color";
import { formatDateTime } from "../../../utils/marketplaceHelpers";
import { getStatusConfig } from "../../../utils/marketplaceHelpers";

const StatusTimeline = ({ statusHistory }) => {
  if (!statusHistory || statusHistory.length === 0) {
    return (
      <div
        style={{
          border: "1px solid #DADADA",
          borderRadius: "12px",
          padding: "20px",
          backgroundColor: "#ffffff",
        }}
      >
        <div
          style={{
            fontSize: "18px",
            fontWeight: "600",
            color: neturalBlack,
            marginBottom: "20px",
          }}
        >
          Status Timeline
        </div>
        <div style={{ color: netural400, fontSize: "14px" }}>
          No history available
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        border: "1px solid #DADADA",
        borderRadius: "12px",
        padding: "20px",
        backgroundColor: "#ffffff",
      }}
    >
      <div
        style={{
          fontSize: "18px",
          fontWeight: "600",
          color: neturalBlack,
          marginBottom: "20px",
        }}
      >
        Status Timeline
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {statusHistory.map((entry, index) => {
          const config = getStatusConfig(entry.status);
          return (
            <div
              key={index}
              style={{
                display: "flex",
                gap: "12px",
                position: "relative",
                paddingLeft: "24px",
              }}
            >
              {/* Timeline dot */}
              <div
                style={{
                  position: "absolute",
                  left: "0",
                  top: "4px",
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  backgroundColor: config.color,
                }}
              />
              
              {/* Timeline line */}
              {index < statusHistory.length - 1 && (
                <div
                  style={{
                    position: "absolute",
                    left: "5px",
                    top: "16px",
                    width: "2px",
                    height: "calc(100% + 8px)",
                    backgroundColor: "#DADADA",
                  }}
                />
              )}

              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                  <span style={{ color: netural400, fontSize: "13px" }}>
                    {formatDateTime(entry.timestamp)}
                  </span>
                  <span
                    style={{
                      color: neturalBlack,
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    {config.label}
                  </span>
                </div>
                {entry.reason && (
                  <div
                    style={{
                      color: netural400,
                      fontSize: "13px",
                      marginTop: "4px",
                      fontStyle: "italic",
                    }}
                  >
                    "{entry.reason}"
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StatusTimeline;
